module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-print-mode",
    attrs: {
      "id": "ql-app"
    }
  }, [_c('md-button', {
    staticClass: "btn-print md-primary md-raised",
    on: {
      "click": _vm.print,
      "touchstart": _vm.print
    }
  }, [_vm._v(_vm._s(_vm.printButtonLabel))]), _vm._v(" "), (_vm.loaded) ? _c('div', {
    staticClass: "print-pages-viewer",
    class: _vm.layout
  }, _vm._l((_vm.projectPages), function(page) {
    return _c('project-print-pages', {
      key: page.pageNumber,
      attrs: {
        "page": page,
        "showMode": _vm.showMode,
        "locked": true,
        "landscape": _vm.layout == 'landscape',
        "versionId": _vm.versionId
      },
      on: {
        "pageReadyFun": _vm.handlePageReady
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.loadPageReady) ? _c('md-layout', {
    staticClass: "loader-wrapper"
  }, [_c('div', {
    staticClass: "loader"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "32",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "stroke-dasharray": "2 4",
      "stroke-dashoffset": "6",
      "d": "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "stroke-dashoffset",
      "dur": "0.6s",
      "repeatCount": "indefinite",
      "values": "6;0"
    }
  })]), _c('path', {
    attrs: {
      "stroke-dasharray": "30",
      "stroke-dashoffset": "30",
      "d": "M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3"
    }
  }, [_c('animate', {
    attrs: {
      "fill": "freeze",
      "attributeName": "stroke-dashoffset",
      "begin": "0.1s",
      "dur": "0.3s",
      "values": "30;0"
    }
  })]), _c('path', {
    attrs: {
      "stroke-dasharray": "10",
      "stroke-dashoffset": "10",
      "d": "M12 8v7.5"
    }
  }, [_c('animate', {
    attrs: {
      "fill": "freeze",
      "attributeName": "stroke-dashoffset",
      "begin": "0.5s",
      "dur": "0.2s",
      "values": "10;0"
    }
  })]), _c('path', {
    attrs: {
      "stroke-dasharray": "6",
      "stroke-dashoffset": "6",
      "d": "M12 15.5l3.5 -3.5M12 15.5l-3.5 -3.5"
    }
  }, [_c('animate', {
    attrs: {
      "fill": "freeze",
      "attributeName": "stroke-dashoffset",
      "begin": "0.7s",
      "dur": "0.2s",
      "values": "6;0"
    }
  })])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aa80718","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/printVersion.vue
// module id = 1249
// module chunks = 21